var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('InfoAlert',{attrs:{"showDismissibleAlert":_vm.showDismissibleAlert,"info":_vm.info},on:{"close":function($event){_vm.showDismissibleAlert = false}}}),_c('EnergyAnalysisReportLists',{attrs:{"report":_vm.report}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }